import { T } from '@tf/utils';

export const getOrgSlugFromUrl = () => {
	const slugPart = window.location.hostname.match(/^[\w-]+/)?.[0].toLowerCase();
	T.assertNotNullish(slugPart, "hostname doesn't not contain tenant subdomain");

	return slugPart;
};
